import { useMutation, useQueryClient } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import api from '@pray/shared/utils/api';

export interface BatchAnalysisResult {
  analyzed: number;
  failed: number;
  total: number;
  skipped: number;
}

interface BatchAnalysisResponse {
  data: BatchAnalysisResult;
}

export interface AnalyzeBatchParams {
  artistId: string;
  scope?: 'unanalyzed' | 'all';
  limit?: number;
}

export async function analyzeBatchConversations({
  artistId,
  scope = 'unanalyzed',
  limit = 50,
}: AnalyzeBatchParams): Promise<BatchAnalysisResult> {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/conversations/analyze-batch`;
  const response = await api.executePostRequest<BatchAnalysisResponse>(url, { scope, limit });

  return response.data.data;
}

export function useAnalyzeBatchConversations() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: analyzeBatchConversations,
    onSuccess: (data, variables) => {
      // Invalidate the conversations list to refresh with new analysis data
      queryClient.invalidateQueries({
        queryKey: queryKeys.artistChatbotConversations(variables.artistId, {}),
      });
      // Invalidate stats as well
      queryClient.invalidateQueries({
        queryKey: queryKeys.artistConversationStats(variables.artistId, {}),
      });
    },
  });
}
